import { useEffect, useMemo } from "react";
import { useI18n } from "@/utils/hooks/i18n.hooks";
import { useAtom } from "jotai";
import { displayAtom } from "@/atoms/display";
import { convertDisplayBreakpoint } from "@/utils/display";
import UAParser from "ua-parser-js";
import { DisplayType } from "@/@types/display";

export const useRootLayout = () => {
  const { initialized } = useI18n();
  const [display, setDisplay] = useAtom(displayAtom);
  const device = useMemo(() => new UAParser().getDevice(), []);

  useEffect(() => {
    const onResizeWindow = () => {
      setDisplay({
        breakpoint: convertDisplayBreakpoint(window.innerWidth),
        type: device.type ? (device.type as DisplayType) : "unknown",
      });
    };
    onResizeWindow();
    window.addEventListener("resize", onResizeWindow);
    return () => window.removeEventListener("resize", onResizeWindow);
  }, [device.type, setDisplay]);

  return { initialized, displayBreakpoint: display };
};
